import PaysSelect from '@/generated/controls/pays/PaysSelect.vue';
import Pays from '@/generated/classes/Pays';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: PaysSelect,
    methods: {
        getDisplay(pays: Pays): string {
            return pays.nom;
        }
    }
})
